import React, { Component } from 'react'
import fetchAds from '../actions/fetchAds'
import { getParams } from '../utils/common'
import { impressionsTracking } from '../utils/tracking'

export default (WrappedComponent) => {
  return class extends Component {
    constructor(props) {
      super(props)
      this.state = {
        response: []
      }
    }

    componentWillMount = () => {
      this.fetchRecWithParams(this.props)
    }

    componentWillReceiveProps(nextProps) {
      this.fetchRecWithParams(nextProps)
    }

    fetchRecWithParams = (props) => {

      const removeEmptyKeys = (obj) => {
        Object.keys(obj).forEach((key) => {
          if (!obj[key]) {
            delete obj[key]
          }
        })
        return obj
      }

      let queryParams = getParams()

      // props values should overwrite params from Datalayer/template_vars
      const newProps = removeEmptyKeys(Object.assign({}, queryParams, props))

      fetchAds(newProps).then(
        response => {
          if(response.length) {
            impressionsTracking(newProps.object_name, 'recommendation', 'recommendation', response, newProps.custom_tag)
          }
          this.setState({
            response: response
          })
        })
    }

  render() {
      return <WrappedComponent response={this.state.response} {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/HOCs/withAds.js